import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {IJsonObject} from "dcerialize";
import {Deserialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import type {IPaginated, IPaginationQuery} from "../../models/IPaginated";
import {Team} from "../../models/Team/Team";
import type {TeamMember} from "../../models/Team/TeamMember";
import {BaseApi} from "./base-api";

@Service()
export class TeamApi extends BaseApi {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("team");
  }

  public getTeam(paginationQuery?: IPaginationQuery): Observable<IPaginated<TeamMember>> {
    const params = this.httpParamsFromPaginationQuery(paginationQuery);
    return this.http.get<IJsonObject>(this.getEndpointUrl(), params ? {params} : undefined)
      // eslint-disable-next-line new-cap
      .pipe(map(json => Deserialize(json, () => Team)));
  }
}
